<template>
    <Head :title="$page.props.title" />

    <AppLayout>
        <template #header>
            <h1>{{ $page.props.title }}</h1>
        </template>
        <Container>
            <div
                class="prose w-full max-w-full rounded bg-white p-8 leading-7 shadow"
                v-html="$page.props.content"
            ></div>
        </Container>
    </AppLayout>
</template>

<script setup>
import { Head } from "@inertiajs/vue3";
import AppLayout from "../Layouts/AppLayout.vue";
import Container from "../Components/Container.vue";
</script>
